import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { StreamChat, Channel } from 'stream-chat';

@Injectable({
  providedIn: 'root'
})
export class StreamChatService {
  private client: StreamChat;

  constructor(private http: HttpClient) { }

  getAnswer(body): Observable<any> {
    return this.http.post<any>(`${environment.apis.lineupproAi}chat`, body);
  }
}
